import parsePhoneNumber from 'libphonenumber-js'

import { canPrePopulate } from 'utils/date/validate'

import { AddressProps } from './types'

export const sanitizeAddress = ({ profile = {}, user = {} }): AddressProps => {
  const { address1, address2, city, state, zip, phoneNumber } = user
  // Update our phoneNumber if resume flow is updated after MFA
  // will only format a number if in the international format and not undefined
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber || '')?.formatNational() ?? phoneNumber
  const { createdAt } = profile
  const can = canPrePopulate(createdAt)

  return {
    address1: (can && address1) || '',
    address2: (can && address2) || '',
    city: (can && city) || '',
    state: (can && state) || '',
    zip: (can && zip) || '',
    phoneNumber: (can && parsedPhoneNumber) || '',
  }
}
